import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export class FormlyTranslateExtension implements FormlyExtension {
  constructor(private translate: TranslateService) {}
  prePopulate(field: FormlyFieldConfig) {
    const props = field.props ?? {};
    if (!props.translate || props._translated) {
      return;
    }
    props._translated = true;
    field.expressions = {
      ...(field.expressions ?? {}),
      'props.label': props.label && props.label !== '' ? this.translate.stream(props.label) : '',
    };
  }
}
export function registerTranslateExtension(translate: TranslateService) {
  return {
    validationMessages: [
      {
        name: 'email',
        message() {
          return translate.stream('formErrors.email');
        },
      },
      {
        name: 'min',
        message(_error: unknown, field: FormlyFieldConfig) {
          return translate.stream('formErrors.min', { min: field.props?.min });
        },
      },
      {
        name: 'minLength',
        message(_error: unknown, field: FormlyFieldConfig) {
          return translate.stream('formErrors.min_length', { chars: field.props?.minLength });
        },
      },
      {
        name: 'passwordComplexity',
        message() {
          return translate.stream('formErrors.password_complexity');
        },
      },
      {
        name: 'passwordConfirm',
        message() {
          return translate.stream('formErrors.password_confirm');
        },
      },
      {
        name: 'required',
        message() {
          return translate.stream('formErrors.required');
        },
      },
      {
        name: 'requiredTrue',
        message() {
          return translate.stream('formErrors.required_true');
        },
      },
    ],
    extensions: [{ name: 'translate', extension: new FormlyTranslateExtension(translate) }],
  };
}
